<template>
  <div>
    <CCard>
      <modals-container v-model="items" />

      <template>
        <CContainer>
          <CModal
            :show="confirmar"
            @close="confirmar = false"
            size="sm"
            class="text-center"
            style="top: 40px"
            color="danger"
            title="Confirmar que quieres eliminar el Segmentación"
          >
            <!-- <CModal-header center :close="false" slot="header">
              <p
                class="heading"
              >Confirmar que quieres eliminar el estereotipo {{stereotypeSelected.name}}</p>
            </CModal-header>-->
            <CModal-header center :close="false" slot="header">
              <p class="heading">
                Confirmar que quieres eliminar el Segmentación
                {{ stereotypeSelected.name }}
              </p>
            </CModal-header>
            <CModalBody>
              <mdb-Icon icon="times" size="4x" class="animated rotateIn" />
            </CModalBody>
            <Cfooter center slot="footer">
              <CButton outline="danger" @click="eliminar()">Si</CButton>
              <CButton color="danger" @click="confirmar = false">No</CButton>
            </Cfooter>
          </CModal>
        </CContainer>
      </template>

      <template>
        <CModal
          :show="modal"
          @close="modal = false"
          color="primary"
          fullHeight
          info
          modal-backdrop
          size="xl"
        >
          <CModal-header center :close="false" slot="header">
            <p class="heading">
              <b>{{ modalName }} Segmentación</b>
            </p>
          </CModal-header>
          <CModalBody class="modal-body">
            <Modal-create-stereotype
              :onClick="closeModalCreate"
              v-if="modalName == 'Crear'"
            ></Modal-create-stereotype>
            <Modal-edit-stereotype
              :onClick="closeModalCreate"
              :stereotype="stereotypeSelected"
              v-if="modalName == 'Editar'"
            ></Modal-edit-stereotype>
          </CModalBody>
          <CModal-Footer center slot="footer">
            <CButton color="danger" @click="modal = false">Cancelar</CButton>
          </CModal-Footer>
        </CModal>
      </template>
      <!-- 
      <mdb-btn color="primary" class="p-2 mb-4" @click="openModal('Crear')">
        <i class="far fa-edit mr-1"></i>
        Nuevo Estereotipo
      </mdb-btn>
      <div slot="header" v-html="caption"></div>-->

      <div class="col-3">
        <CButton
          color="primary"
          class="p-2 mb-4 mt-4"
          @click="openModal('Crear')"
        >
          <i class="far fa-edit mr-1"></i>
          Nuevo Segmentación
        </CButton>
      </div>
      <!-- <div class="col 3">
        <label class="typo__label">Genero</label>
        <multiselect
          v-model="genderSelected"
          deselect-label
          placeholder="Seleccione el genero"
          track-by="id"
          label="name"
          :options="genders"
          :searchable="true"
          :allow-empty="false"
        ></multiselect>
      </div>-->
      <CCard class="p-3">
        <CDataTable
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="items"
          :fields="captions"
          :current-page="currentPage"
          :items-per-page="10"
          column-filter
          sorter
          pagination
        >
          <template slot="gender" slot-scope="data">
            <CCol>
              <CBadge color="primary" v-if="data.item.gender == '1'" class="p-2"
                >Hombres</CBadge
              >
              <CBadge color="warning" v-if="data.item.gender == '2'" class="p-2"
                >Mujeres</CBadge
              >
              <CBadge color="success" v-if="data.item.gender == '3'" class="p-2"
                >Todos</CBadge
              >
            </CCol>
          </template>

          <template slot="acciones" slot-scope="data">
            <CCol>
              <CRow>
                <div class="seleccionar col-lg-4 col-md-12">
                  <CBadge
                    color="primary"
                    class="p-2 mt-2 mr-2"
                    @click="selectStereotypeEdit(data.item, items)"
                  >
                    <i class="far fa-edit mr-1"></i>Editar
                  </CBadge>
                </div>
                <div class="seleccionar col-lg-4 col-md-12">
                  <CBadge
                    color="danger"
                    class="p-2 mt-2"
                    @click="selectStereotypeDelete(data.item)"
                  >
                    <i class="far fa-trash-alt mr-1"></i>Eliminar
                  </CBadge>
                </div>
              </CRow>
            </CCol>
          </template>
        </CDataTable>
      </CCard>
      <nav>
        <!-- <CPagination
          :total-rows="totalRows"
          :item-per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />-->
      </nav>
    </CCard>
  </div>
</template>

<script>
import store from "../../store";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateStereotype from "../notifications/ModalCreateStereotype";
import ModalEditStereotype from "../notifications/ModalEditStereotype";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
} from "mdbvue";
export default {
  name: "table-stereotype",
  inheritAttrs: false,
  components: {
    ModalCreateStereotype,
    ModalEditStereotype,
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
  },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: [Array, Function],
      default: () => [],
    },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      currentPage: 1,
      modal: false,
      modalName: "",
      isLoadingLine: false,
      confirmar: false,
      stereotypeSelected: {},
      genderSelected: {},
      genders: [
        //4th tab
        { name: "Hombre", id: 1 },
        { name: "Mujer", id: 2 },
        { name: "Ambos", id: 3 },
      ],
    };
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function () {
      return this.getRowCount();
    },
    captions: function () {
      return this.fields;
    },
  },
  methods: {
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function () {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    crearLine(event) {
      event.target.classList.add("was-validated");
      var { nameLine, descriptionLine } = this;
      this.isLoadingLine = true;
      if (nameLine == "" || descriptionLine == "") {
        this.isLoadingLine = false;
      } else {
        var line = {
          nameLine,
          descriptionLine,
        };
        store.dispatch("newLine", line).then(() => {
          this.nameLine = "";
          this.descriptionLine = "";
          this.isLoadingLine = false;
          this.modal = false;
        });
      }
    },
    openModal(opcion) {
      this.modalName = opcion;
      this.modal = true;
    },
    createStrategy() {
      this.modalName = "Crear";
      this.modal = true;
    },
    selectStereotypeEdit(item, items) {
      this.stereotypeSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    selectStereotypeDelete(item) {
      this.stereotypeSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteStereotypeUtility", this.stereotypeSelected.id);
      }, 400);
      store.dispatch("deleteStereotypeAction", this.stereotypeSelected.id);
      this.confirmar = false;
    },
  },
};
</script>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}
</style>
